import React, { useCallback, useEffect, useRef, useState } from "react";
import S from "./AugmentedMessage.styled";
import detectMessageUrls, { isEmoji, prependSchemeToUrl, } from "./utils";
import { useChannel } from "../..";
import ReplyMessage from "./ReplyMessage";
const renderMessageText = (tokens) => {
    return tokens.map((token, i) => {
        if (token.type === "link") {
            const index = token.link + i.toString();
            const prependSchema = prependSchemeToUrl(token.link);
            return (React.createElement(S.Anchor, { key: index, rel: "noreferrer", href: prependSchema, target: "_blank" }, token.link));
        }
        if (token.type === "email") {
            const index = token.email + i.toString();
            const email = `mailto:${token.email}`;
            return (React.createElement(S.Anchor, { key: index, href: email, target: "_blank" }, token.email));
        }
        return token.text;
    });
};
const renderMessageIframe = (sources) => {
    return sources.map((source, i) => {
        const index = source + i.toString();
        return (React.createElement(S.IFrameWrapper, { key: index },
            React.createElement(S.IndentedIframe, { src: source, frameBorder: "0", allow: "accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture; ", allowFullScreen: true, title: "Embedded video" })));
    });
};
const AugmentedMessage = ({ status, message, editableMessageId, setEditableMessageId, }) => {
    var _a;
    const channel = useChannel();
    const [isEditable, setIsEditable] = useState(false);
    const [mediaUrls, tokens] = detectMessageUrls(message.text);
    const media = renderMessageIframe(mediaUrls);
    const messageText = renderMessageText(tokens);
    const [updatedMessage, setUpdatedMessage] = useState(message.text);
    const plainMessage = tokens.filter((token) => token.type === "text");
    const textAreaElement = useRef(null);
    const isOnlyEmoji = isEmoji(plainMessage);
    const handleChange = useCallback(({ target }) => {
        setUpdatedMessage(target.value);
    }, [setUpdatedMessage]);
    useEffect(() => {
        if (textAreaElement && textAreaElement.current) {
            textAreaElement.current.focus();
        }
    }, [textAreaElement.current]);
    useEffect(() => {
        if (editableMessageId) {
            setIsEditable(editableMessageId === message.serverId);
        }
    }, [editableMessageId, message.serverId]);
    return (React.createElement(React.Fragment, null,
        React.createElement(S.Text, { status: status },
            React.createElement(ReplyMessage, { message: (_a = message.reply) !== null && _a !== void 0 ? _a : null }),
            isEditable ? (React.createElement(S.TextAreaWrapper, null,
                React.createElement(S.Textarea, { minRows: 1, maxRows: 10, maxLength: 2048, value: updatedMessage, onChange: handleChange, ref: textAreaElement }),
                React.createElement(S.ButtonGroup, null,
                    React.createElement(S.SaveButton, { type: "button", onClick: () => {
                            channel.updateMessage(Object.assign(Object.assign({}, message), { text: updatedMessage }));
                            setEditableMessageId === null || setEditableMessageId === void 0 ? void 0 : setEditableMessageId("");
                            setIsEditable(false);
                        } }, "Save changes"),
                    React.createElement(S.Button, { onClick: () => {
                            setEditableMessageId === null || setEditableMessageId === void 0 ? void 0 : setEditableMessageId("");
                            setIsEditable(false);
                        } }, "Cancel")))) : (React.createElement(S.TextSize, { isJustEmoji: isOnlyEmoji },
                messageText,
                " ",
                message.edited ? React.createElement(S.Span, null, "(edited)") : ""))),
        media));
};
export default AugmentedMessage;
//# sourceMappingURL=AugmentedMessage.js.map